// Reads data/cards.csv into card definitions.
// Columns: number, name, image, rarity, type, cost, cost_type, affiliation, limit, starting_hand,
//          tiers, arrival, discard_aura, movement, abilities, range, health, shares_lane, extra_slots,
//          count, turns, removal_cost, replay_cost, on_play, field_aura, while_in_play, freed_gains, leans,
//          damage, shield, buffer, thorns, heals, duration, traits, stats, text
//  - text: the card's description, as printed in its text box and shown in its close-up. Status effects,
//    card types, affiliations and rarities are written with a capital letter; status effects get a colored
//    box by themselves (the words are listed in src/config.ts under cardText.statusWords). A line break
//    inside the cell starts a new paragraph ("Entrance: …" / "Passive: …").
//  - traits: the card's descriptor lines, separated by " | " (Single Damage | Target | Ground). They are
//    printed in the bar above the text box, after the card's type.
//  - damage, shield, buffer, thorns, heals: the card's printed stats. Each cell holds what the card shows:
//    usually a number, sometimes two ("12/3": first attack / later attacks) or "?" (worked out in play).
//    On a Troop, Building or Emperor, shield / buffer / thorns are also COUNTERS IT ARRIVES WITH: the table
//    puts a Shield, Buffer or Thorns counter on it at that number as it comes into play. Several numbers
//    separated by "/" are several counters ("1/1/1/1" = four separate Shields of 1: Ghostly Armor); a 0 or
//    a "?" puts none. On a Spell these cells only say what the Spell gives, and nothing is placed.
//    heals = how much a Spell or Building heals (the heart on a card that has no health of its own).
//  - duration: for a Spell whose effect lasts a number of turns but which gets no turn timer of its own
//    (its `turns` cell is blank): the number is only shown on the card.
//  - stats: leave blank. Only for the rare card whose printed stats don't fit the cells above (two bodies in
//    one card): what to print instead, as "name value" pairs separated by " | "
//    (health 15/20 | shield 1 | count 2 | damage 4/2). Names: health, sp, heals, shield, buffer, count,
//    damage, thorns, range, turns, removal, replay.
//  - number: the card's set number. A row with NO number, or "summon", is a spawn-only card: a unit that other cards
//    summon. It has no rarity, never shows in the deck builder and can't be put in a deck; it is found
//    only in the table's Spawn menu (Cards tab).
//  - cost: usually one number. Two other things can go in this cell:
//      3/7   the card can be summoned for either cost, and the player chooses as they play it. Its health
//            cell then holds the health for each, the same way round: 16/20 (Forgotten Monarch)
//      a formula, for a cost worked out as the card is played: gerzite, 2 + cards_removed,
//            up(discard / 2) + 1 … (see src/shared/costs.ts for everything a formula can hold)
//  - cost_type: "dark" = the cost is paid in Dark Gerzite instead of Gerzite. Such a card is summoned with
//    Dark Gerzite by nature, so it can't be played as a Darkgale summon. Blank = Gerzite.
//  - shares_lane: "yes" = may be summoned into a lane that already holds a unit
//  - count: for a card that is several small units in one (Skell-Minis: 3). It arrives with a Count
//    counter showing that number, to lower as they fall. Blank = no counter.
//  - turns: for a Biome, Tome or Spell, how many of its owner's turns it stays active. It arrives with a turn
//    timer at this number; when the timer runs out, a Destroyed token marks the card as no longer active.
//    A bare number gets an End of Turn Timer. "3 start" gets a Start of Turn Timer instead, "3 end" says
//    End of Turn outright.
//    A "?" instead of the number ("? start") is for a card whose turn count isn't fixed: it arrives with a
//    timer showing "?" that does not count down until its owner sets the number by hand (click the timer).
//    "8 up" gets a Count-Up Timer instead: it starts at 0, gains 1 as each of its owner's turns begins and
//    stops at 8. The card doesn't end when it gets there (Arcane Charge).
//  - brings: tokens the card arrives with, tied to it. "lock 3" = a Locked token that costs 3 Gerzite to take
//    off, "lock 2 dark" = one that costs 2 Dark Gerzite, "burn" = a Burn token, "weakness 2" = a counter at 2.
//    The token appears beside the card for its owner to drag onto the target. Add "here" to put it on the
//    card itself, and "opponent" for a Lock only the opponent may pay ("lock 4 here opponent": Persistent
//    Shield). "summoner" puts it on the nearest of its owner's cards named in summoned_by instead (a Leviathan
//    Body Segment's Health and Range go on its Leviathan). Two or more Link tokens one card brings share one
//    new number, so they link the cards they end up on. "each undead" puts one on every face-up Unit its owner
//    controls that is Undead (any affiliation works) as the card arrives ("aff-volcanic each undead": Dark
//    Sovereign marks the Undead it turns Volcanic). Several, separated by "/".
//    A summoned unit (a "summon" row) brings its tokens when it is taken from the Spawn menu, too.
//  - ends: how the card ends, other than by a turn count. Tags separated by "/":
//    "token_gone" = when a token it brought is no longer on the table (its Lock was paid, its Burn was cured);
//    "recast" = once it has ended, its owner may pay its cost again to recast it (it brings a new token);
//    "opponent_rolls_even" = as each of the opponent's turns begins they roll a die, and an even roll ends it.
//    Ending is the same as a turn timer running out: a Destroyed token marks the card as no longer active.
//  - removal_cost: what either player pays in Gerzite to take a Biome out of play early (shown on the card's
//    close-up; nothing is paid automatically)
//  - replay_cost: what a Tome's owner pays in Gerzite to keep it in play once its turns are over (shown too)
//    Either of these is paid in Dark Gerzite if the cell says so after the number: 2/dark (or "2 dark").
//  - on_play: things the table does by itself when the card is played face-up, separated by "/":
//      copy_last_card   a copy of the last card your opponent played is spawned on your side (Reflective Orb)
//      no_end_gerzite   you gain no Gerzite at the end of this turn, and the log says why (Crystalline Discharge)
//      discard_recycle  if its player has more cards in their discard pile than their opponent, the card is
//                       discarded, the discard pile shuffled, its top 4 cards put into the deck, the deck shuffled,
//                       and its top card drawn; otherwise it stays, with no effect (Cosmic Beyonder's Entrance)
//      coin_gerzite     its caster rolls a die for a coin flip: even = heads, they gain Gerzite; odd = tails, the
//                       opponent gains Gerzite (Magical Coin). The amounts are coinGerzite in src/config.ts.
//                       The card is discarded once the roll is made.
//  - on_untap: what happens to the tokens the card arrived with on it (its "brings ... here" tokens) when it is
//    untapped: lose_tokens = they come off the first time (Firelance's Special Hit); swap_tokens = they come off,
//    the next untap puts them back, and so on (Sunken Soldier's Range and Special Hit). Blank = nothing.
//  - field_aura: a fog that covers this card's owner's half of the mat while the card is face-up in play, seen
//    only by the OTHER player: fog (Fog) or smog (Smog). The looks are in src/config.ts under fieldAuras.
//  - while_in_play: things that hold for as long as the card is face-up in play, separated by "/":
//      reveal_hands   both players' hands are in plain view (Lexicon of Truth)
//      no_dark_spend  its owner can't spend Dark Gerzite while it is in play and not destroyed (Gemstone Hoarder)
//      steal_dark     each time an opponent gains Dark Gerzite, 1 of theirs moves to its owner's bar (Gemstone Hoarder)
//      untouchable    it can't be damaged, can't carry status effects, doesn't arrive Entrenched and has no SP decay
//      intangible     it can't be damaged or targeted and doesn't fill its lane, but still attacks and takes statuses (Spirit Soldier)
//      double_lanes   a Biome: while it is active, each lane on both sides holds two cards instead of one (Vast Expanse)
//                     (Calling Pillar; give it shares_lane = yes too, so it never blocks a lane)
//      calling        with one of these in every one of its owner's lanes: they discard their hand, the card
//                     tagged jumps comes from their deck or discard pile to their hand, they gain Gerzite, and
//                     every one of these in their lanes is discarded (Calling Pillar)
//      remaining_gate while it is active, cards tagged needs_gate can be played (Realm Beyond Comprehension)
//      needs_gate     it can only be played while a remaining_gate card is active (The Remaining)
//      jumps          it can never be drawn or taken from a pile; as each of its owner's turns begins it moves
//                     to another place in the pile it is in (The Remaining)
//      (on_play, for the same cards: lane_damage = damage to every Unit in its lane as it is played;
//       field_wipe = damage to every other Troop and Building on both sides. Numbers: CONFIG.secretRares)
//      tap_relock     each time it is tapped, the tokens its brings cell puts on it ("lock 1 here") are put on it
//                     again (Cannoneer: Locked for 1 Gerzite as it arrives, and again after every tap)
//      tap_harvest    the first time it is tapped each turn it gains 1 on its Harvest counter, which its owner
//                     spends for Gerzite or Dark Gerzite (Gerzite Farmer; the numbers are CONFIG.harvest)
//      limbo_discards as it becomes active, each player's discard pile is set aside in a Limbo pile, out of
//                     reach (new discards go to the discard pile as usual); when it ends (its turns run out or
//                     it leaves the table), each player shuffles Limbo into their discard pile and draws its
//                     top card if they have fewer than 10 in hand (Heart of Limbo)
//  - destroyed_gains: what its owner gains when the card leaves the table (discarded, or a summoned unit thrown
//    off) face-up with a Destroyed token on it, as "token number" (Gerzite Farmer: gerzite 1). The token is a
//    bar token from tokens.csv: gerzite or dark-gerzite. Blank = nothing. After the number you can add:
//      opponent  the other player gains it instead (gerzite 1 opponent)
//      each      a card of several units (a Count) pays for EACH unit, at the moment that unit falls: when
//                damage fells one, when its Count is turned down by hand, and for the units still counted when
//                the card leaves with a Destroyed token (Gerzite Crystallites: gerzite 1 opponent each)
//    Instead of a number, "double" doubles what that player has (Gemstone Hoarder: dark-gerzite double).
//  - set: which set the card belongs to (blank = the Base Set; bab = Bones & Bruises; the sets are in CONFIG.sets). A card
//    of another set has its number in that set in the number cell (Undead Legion: 1). Each pack holds the cards of one set only, so
//    when a new set is added, give its cards its name here and give it packs of its own (src/shared/packs.ts).
//  - effects: what the card does by itself, now that the table deals attacks. One or more rules separated by ";",
//    each written   [passive] <moment>: <what> [on <whom>] [if <condition>] [if <condition>]…
//    "passive" in front = it is a "Passive:" effect (stopped while the card is Entrenched, Comatose, Frozen,
//    Locked or Stunned). Examples:   passive kill: status overheal 2 on self      (Duskwolf)
//                                    hit: status burn on target                   (Pyre Hatchling)
//                                    start: summon Skell-Mini                     (Headstone)
//                                    deal: x2 vs rarity legendary grand ancient   (Highcard Assassin)
//    moments: enter (played face-up) · hit (one of its hits hurt a card) · attack (it has attacked) · kill (it
//      destroyed what it hit) · shieldbreak (it broke a Shield) · shield_gone (its own last Shield broke) · hurt (an attacker hurt it) · damaged (it took damage from anything) ·
//      destroyed · ally_destroyed / foe_destroyed (another card was: "it") · emperor_damaged · start / end (its
//      owner's turn begins / reaches its End Phase) · any_start (every turn) · attack_phase · tap (its Tap ability)
//    what: status <token> [number] [for <turns>] · lock <price> · damage <n|half|lost> [pierce] · wound <n> (straight
//      onto its health) · heal <n> · health <n> · gain <n> gerzite|dark · draw <n> · summon <Unit> [x2] [max 3]
//      [front] [ambush] · destroy · shuffle (the opponent's deck) · transfer (its statuses to the target) ·
//      steal <n> · lose <token> <n> · overload <boost> <damage> · pay <n> gerzite|dark
//    whom: self, target, attacker, attacker_unit (the attacker only if it is a Troop or Building: a card that says "Unit" never means an Emperor), it, front (the lane across), front_or_emperor, target_lane, adjacent (the lanes
//      either side of the one attacked), allies_adjacent, allies_range, lane, lane_one (the most hurt in its lane),
//      emperor, foe_emperor, emperors
//    conditions ("!" in front turns one round): biome <affiliation> · untapped · alive · my_turn · dealt ·
//      status <token|any> · mate <affiliation> · target emperor|unit · it <affiliation> · full_count · all_in ·
//      hurt_last_turn · rested · health<=10 · health>=11
//    Choices: "on pick_foe" (also pick_foe_all, pick_foe_range, pick_front, pick_ally, pick_ally_all, pick_ally_range,
//      pick_any) asks the card's owner to click one of those cards; rules after it can say "on it" for the same card.
//      "if pool affiliation forested", "if pool troop", "if pool hurt", "if pool other" (not itself), "if pool new"
//      (not one already chosen) narrow the choice; "if may" lets it be passed.
//    More moments: targeted (counter 2 3: pay 2 Gerzite, 3 against an Emperor, to strike first) · drawn (its owner
//      drew a card; "if card frigid") · use (an Emperor ability, in emperor_abilities.csv)
//    More to do: link (a pair of Link counters) · split · hold 1 (stays tapped an extra turn) · clone <Unit> ·
//      rebirth · search deck|discard [affiliation …] [type spell|support|…] [to top] [x2] ·
//      reveal 2 [look] keep affiliation … [gain 2] [else discard] · discount 1 [affiliation …] [type …] [turn]
//    cost: -1 type tome · cost: +1 foe affiliation spectral · "per count", "first" (see costChange in engine.ts)
//    always: leads (what it summoned attacks with it) · always: brain · always: tally health affiliation forested
//    Support cards: trigger: attack | biome | spell | tome | summon | discard | overdraw | tierup | emperor | aff <affiliation>
//      (a Trigger: what its owner's opponent has to do for it to spring) · expired (its turns ran out) · any_end
//      (each player's End Phase: "gain 1 gerzite actor" pays whoever's turn it is) · any_summon / ally_summon (a Unit
//      was played: "it") · any_destroyed · any_drawn. An aura with "both" reaches both sides of the field (a Biome);
//      with "field", all of its owner's side (a Tome); "units" leaves Emperors out; "unentrenched" skips Entrenched cards.
//      Auras: damage, range, buffer, thorns, frenzy, antiair.
//    Choices: "choose Stun_a_Unit/Add_a_cooldown" asks which; the rules after it say "if chose 1" / "if chose 2".
//      "choose lane foe|own" asks for a lane (for snare, resurrect). "if else_emperor": with no card left to pick,
//      it goes to the opposing Emperor. "cap 3" on a status: no more than 3 from this card on one card; "ungive
//      <token>" takes back what it gave.
//    Bones & Bruises: attacked (it was attacked, whatever the damage: "attacker") · foe_moved (an opposing Unit moved to
//      another lane: "it") · fractal (it earned its player a Fractal by not attacking) · ally_fractal (a Unit on its side did:
//      "it") · "deal: +2 vs flying" · "always: air_range" (its range only reaches Flying Units) · "always: bulwark" (an
//      Undead Guard: takes every hit aimed at its lane) · "always: no_fractal" (it never earns its player a Fractal for not attacking: Star Observatory) · "always: well" (Gravity Well) · "always: vacuum" (no positive
//      statuses in its marked lanes) · verbs aim (only picks "it"), intercede, wrath, rewind, sever, recall, reactor,
//      "gain 1 fractal" · conditions it_building, it_hurt, last_summoned
//    Standing rules use these moments instead:
//      deal: +2 vs affiliation frigid duned · deal: x2 vs rarity grand · deal: +1 per affiliation volcanic ·
//            deal: +1 per lost (each unit of its Count that has fallen) · deal: pierce · deal: x2 if hurt_last_turn
//      take: -1 from affiliation submerged · take: cap 3 once
//      frenzy: on [if …]   (it has Frenzy)      always: no_decay
//      aura: damage 2 | range 2 | buffer 1   (its owner's units within its range; add "field" for all of them,
//            "affiliation submerged" for only those)
//  - freed_gains: tokens the card is given when its Entrenched ends, as "token number" separated by "/"
//    (Hexed Mummy: decay 2/weakness 2/susceptible 2). Token names are effects from tokens.csv.
//  - leans: deck archetypes this card pulls a deck toward, for the Deck Stats guess. Any of aggro, tempo,
//    control, beatdown, cycle, bait, combo, siege, support, counter, brainrot, mastermind, typecast, synergy, midrange,
//    ramp, swarm, direct_attack, mill, stall, prison, sacrifice, voltron, toolbox, disruption, token, alt_win, separated
//    by "/" (blank = none; "direct attack" with a space works too)
//  - roles: what the card does in a deck, for the deck builder's Role filter. Any of win condition, damage dealer,
//    support, tank, separated by "|" or "/" (blank = none; a card can have several)
//  - extra_slots: slots this card may be placed in on top of the ones its type allows (see slotsFor in
//    src/config.ts). Any of lane, minion, emperor, spell, support, biome, separated by "/" (blank = none)
//  - abilities: any of entrance, passive, tap, separated by "/" (e.g. entrance/tap)
//  - range: a number, for cards that have a range value (blank = none)
//  - health: the card's full health, or SP for a Building (blank = not set)
//  - limit: blank = the usual limit for the card's rarity (12, 12, 10, 10, 8, 5, 4, 3, 2)
//  - type and affiliation can hold two values separated by "/" (e.g. forested/undead)
//  - leave image blank to use a drawn placeholder
//  - limit = max copies of that exact card in a deck (Emperors are always 1)
//  - starting_hand = leave blank for normal cards; "no" keeps the card out of your
//    starting hand (it stays in the deck and can be drawn later)
//  - tiers = leave blank: a card's tiers come from its type (tierRules in src/config.ts). A number here can
//    only lower them: 1 = this card never merges, 2 = it stops at Tier II.
//  - flavor = the italic line printed under the description (blank = none)
//  - spread_unit = a Lanespanner only: the name of the summoned unit (a "summon" row) its extra units are, when it
//    spreads across lanes (Royal Line → Royal Guard). Blank = the extra units are copies of the card itself.
//  - arrives_with = summoned units (names of "summon" rows) that arrive with this card, attached to its bottom
//    edge (Zombie Knight: Zombie Horse). "x2" after a name for two. Separated by "/".
//  - destroyed_summons = summoned units that appear in this card's lane when it is destroyed (its health or SP
//    reaches 0): Battering Ram: Skell-Mini x2, Blockhead Zombie: Chicken. Separated by "/".
//  - summoned_by = a summoned unit (a "summon" row) only: the cards that summon it, separated by "/"
//    (Skell-Mini: Necromancer/Headstone/…). Its "summoner" tokens go on the nearest of these (see brings).
//  - art_x, art_y, art_zoom = moving the art inside the card's art window, when the automatic fit cuts
//    something off: art_x / art_y in pixels on the 750 x 1050 card (art_x 30 = 30 px right, -30 = left;
//    art_y 30 = down, -30 = up), art_zoom in percent (120 = 20% bigger). Blank = centered, just filling it.
//  - arrival = blank for normal cards (they arrive Entrenched: turned to face your
//    opponent); "ambush" = arrives facing you, ready to go, with a swift effect;
//    "entrenched 2" (or just "2") = arrives Entrenched for that many turns instead of 1
//  - discard_aura = "yes" gives the card an orbiting aura that grows and shrinks with
//    the size of its owner's discard pile
//  - movement = "ground" or "flying" (blank = neither); flying cards hover above the table
import { csvToRecords } from './csv.ts';
import { CONFIG } from '../config.ts';
import { describeFormula, parseCostFormula, type CostFormula } from './costs.ts';

export const RARITIES = [
  'common', 'uncommon', 'rare', 'ultra-rare', 'epic', 'mythic', 'legendary', 'grand', 'ancient',
] as const;
export const CARD_TYPES = ['emperor', 'troop', 'building', 'spell', 'biome', 'trigger', 'tome'] as const;
export const AFFILIATIONS = [
  'astral', 'duned', 'forested', 'frigid', 'magical', 'spectral', 'submerged', 'undead', 'volcanic', 'neutral',
] as const;
export const COSTS = Array.from({ length: 20 }, (_, i) => i + 1);
/** The deck archetypes: what the Deck Stats panel guesses between, and what a card's `leans` cell may name. */
export const ARCHETYPE_IDS = [
  'aggro', 'tempo', 'control', 'beatdown', 'cycle', 'bait', 'combo', 'siege', 'support', 'counter', 'brainrot', 'mastermind', 'typecast', 'synergy',
  'midrange', 'ramp', 'swarm', 'direct_attack', 'mill', 'stall', 'prison', 'sacrifice', 'voltron', 'toolbox', 'disruption', 'token', 'alt_win',
] as const;

/** What a card does in a deck (its `roles` cell): the deck builder's Role filter. */
export const ROLES = ['win condition', 'damage dealer', 'support', 'tank'] as const;

export const DEFAULT_LIMIT = 12;
/** How many copies of one card a deck may hold, by rarity, when the card's own limit cell is blank. */
export const RARITY_LIMITS: Record<string, number> = {
  common: 12, uncommon: 12, rare: 10, 'ultra-rare': 10, epic: 8, mythic: 5, legendary: 4, grand: 3, ancient: 2,
};

/** Spawn-only cards (rows with no number) are kept under made-up numbers from here up, in the order of their rows. */
export const SPAWN_ONLY_FROM = 9001;

export interface CardDef {
  number: number; // the set number (for a spawn-only card: a made-up number the game uses to tell it apart)
  spawnOnly: boolean; // no set number: only in the Spawn menu, never in a deck
  name: string;
  image: string; // file name inside public/cards/, or '' for a placeholder
  formImages?: string[]; // a card with two costs and an art for each ("forgottenmonarch1/forgottenmonarch"): the art for each form, the first being `image`
  rarity: string;
  types: string[];
  cost: number | null;
  costDark: boolean; // the cost is paid in Dark Gerzite, not Gerzite (the `cost_type` cell says dark)
  // a card that can be summoned at more than one cost (cost cell "3/7", health cell "16/20"): each way, in
  // order. `cost` and `health` hold the first one. null for every ordinary card.
  // ways to summon it, chosen as it is played: two costs (3/7 → 16/20 health), or one cost and two shapes
  // (Clay Soldiers: one Troop with 25 health, or four with 5 each: health 25/5, count 1/4)
  forms: { cost: number; health: number | null; count: number | null }[] | null;
  costFormula: CostFormula | null; // a cost worked out as the card is played (then `cost` is null)
  affiliations: string[];
  limit: number;
  startingHand: boolean; // false = never dealt into a starting hand
  set: string; // which set it belongs to (the `set` cell; blank = 'base', the Base Set): a pack only holds cards of its own set
  setNumber: number; // its number within its set (Bones & Bruises #1); for the Base Set the same as `number`
  tiers: number; // 1 = can't merge; 2 or 3 = highest tier it can merge up to (from its type: maxTier)
  arrival: 'entrenched' | 'ambush';
  entrenchedTurns: number; // how many turns it arrives Entrenched for (1 unless its arrival cell says more, e.g. "entrenched 2")
  discardAura: boolean;
  movement: '' | 'ground' | 'flying';
  abilities: string[]; // any of: entrance, passive, tap (each one adds a small effect on the table)
  sharesLane: boolean; // may be summoned into a lane that already holds a unit (every summoned unit can)
  arrivesWith: { name: string; count: number }[]; // summoned units that arrive attached to it (the `arrives_with` cell)
  destroyedSummons: { name: string; count: number }[]; // summoned units that appear in its lane when it is destroyed (`destroyed_summons`)
  summonedBy: string[]; // a summoned unit: the names of the cards that summon it (the `summoned_by` cell)
  spreadUnit: string; // a Lanespanner: the summoned unit its extra units are (the `spread_unit` cell, a summon card's name; '' = copies of itself)
  count: number | null; // how many small units the card holds: it arrives with a Count counter at this number
  turns: number | null; // a Biome, Tome or Spell: how many of its owner's turns it lasts (it arrives with a turn timer at this number)
  turnsTimer: 'start' | 'end' | 'up' | null; // which timer that is, if its turns cell says ("3 start"); null = the usual one. 'up' = a Count-Up Timer that stops at `turns`
  turnsUnset: boolean; // its turns cell has a "?" for the number: it arrives with a timer its owner sets by hand
  removalCost: number | null; // a Biome: Gerzite either player pays to remove it early
  removalDark: boolean; // …in Dark Gerzite instead (the cell says "5/dark")
  replayCost: number | null; // a Tome: Gerzite its owner pays to keep it once its turns are over
  replayDark: boolean; // …in Dark Gerzite instead (the cell says "2/dark")
  brings: CardBrings[]; // tokens it arrives with, tied to it (the `brings` cell)
  ends: string[]; // how it ends other than by a turn count (the `ends` cell): see ENDS
  onPlay: string[]; // what the table does by itself when the card is played face-up (the `on_play` cell): see ON_PLAY
  onUntap: '' | 'lose_tokens' | 'swap_tokens'; // what happens to the tokens it arrived with (`brings ... here`) when it is untapped (the `on_untap` cell)
  whileInPlay: string[]; // what holds for as long as the card is face-up in play (the `while_in_play` cell): see WHILE_IN_PLAY
  fieldAura: string; // a fog over its owner's half of the mat while it is in play, for the other player to see ('' = none)
  effects: CardEffect[]; // what it does by itself (the `effects` cell): see CardEffect
  destroyedGains: { token: string; amount: number; double: boolean; opponent: boolean; each: boolean } | null; // gained when it is discarded from play with a Destroyed token on it (the `destroyed_gains` cell)
  freedGains: { effect: string; value: number }[]; // tokens put on the card when its Entrenched ends (the `freed_gains` cell)
  leans: string[]; // deck archetypes this card pulls a deck toward (the `leans` cell); see LEAN_RULES in archetypes.ts for the automatic ones
  roles: string[]; // what it does in a deck (the `roles` cell): any of ROLES
  extraSlots: string[]; // kinds of slot this card may use on top of its type's own: 'biome', 'lane', 'spell'… (lower case)
  health: number | null; // full health (SP for a Building); used by the Sacrifice helper and the fallen-Emperor notice
  range: number | null; // the card's range value, if it has one (kept for later; nothing on the table uses it yet)
  // What the card prints, as written in its cells (so "12/3" and "?" stay as they are): see cardStats()
  rangeText: string;
  damage: string;
  shield: string;
  buffer: string;
  thorns: string;
  heals: string; // how much a Spell or Building heals
  duration: string; // a Spell's turn count, when it gets no turn timer of its own (shown only)
  statsOverride: string; // the `stats` cell: printed instead of the stats worked out from the cells above
  traits: string[]; // its descriptor lines after the type: Single Damage, Target, Ground
  text: string; // its description
  flavor: string; // the italic line under the description (the `flavor` column; '' = none)
  // Moving the art inside the card's art window (the art_x, art_y and art_zoom columns): pixels on the
  // 750 x 1050 card (art_x + = right, art_y + = down) and a zoom in percent (100 = just fills the window).
  art: { x: number; y: number; zoom: number };
  emperorAbilities: EmperorAbility[]; // an Emperor's abilities, in slot order (from data/emperor_abilities.csv); empty for every other card
}

/**
 * One of an Emperor's abilities: its owner clicks the Emperor and pays `cost` to use it, and it can't be used
 * again until its cooldown is over. The table handles the cost and the cooldown; what the ability DOES is
 * `text`, for the players to carry out.
 */
export interface EmperorAbility {
  slot: number; // 1 or 2
  name: string;
  cost: number; // Gerzite (or Dark Gerzite, if `dark`)
  dark: boolean;
  costVaries: boolean; // the cost cell says "?": it is worked out as the ability is used, so the table takes nothing and its owner pays by hand
  cooldown: number; // turns: a Start of Turn Timer at this number goes on the Emperor when the ability is used (0 = none)
  text: string; // what it does, in words
  effects: CardEffect[]; // what the table carries out as it is used (the `effects` cell: "use: …" rules, like a card's)
  // When it can be used (the `when` cell). `phases`: the phases of its owner's own turn it can be used in
  // (0 Overdraw, 1 Summon, 2 Attack, 3 End); null = the usual ones (emperorAbilities.phases in the settings:
  // the Attack Phase); [] = never on its owner's turn. `opponentTurn`: it can also be used on the other
  // player's turn.
  phases: number[] | null;
  opponentTurn: boolean;
}
/** What the `when` cell of emperor_abilities.csv can hold, and what each word means. */
export const ABILITY_WHEN: Record<string, { phases?: number[]; opponentTurn?: boolean }> = {
  overdraw: { phases: [0] },
  summon: { phases: [1] },
  attack: { phases: [2] },
  end: { phases: [3] },
  any_phase: { phases: [0, 1, 2, 3] },
  opponent_turn: { opponentTurn: true },
  any_time: { phases: [0, 1, 2, 3], opponentTurn: true },
};
/** How many abilities an Emperor has room for (the menu shows this many slots). */
export const EMPEROR_ABILITY_SLOTS = 2;

export const ABILITIES = ['entrance', 'passive', 'tap'] as const;
/** What the `on_play` cell can ask the table to do when a card is played face-up. */
export const ON_PLAY = ['copy_last_card', 'no_end_gerzite', 'coin_gerzite', 'discard_recycle', 'lane_damage', 'field_wipe'] as const;
/** How a card can end other than by a turn count (the `ends` cell). */
export const ENDS = ['token_gone', 'recast', 'opponent_rolls_even'] as const;
/** One token a card arrives with (the `brings` cell): "lock 3", "lock 2 dark", "lock 4 here opponent", "burn". */
export interface CardBrings {
  token: string; // a token's id or effect ("lock" is read as "locked")
  value: number | null; // a Lock: what it costs to take off · a counter: its number
  dark: boolean; // a Lock: paid in Dark Gerzite
  here: boolean; // it goes on the card itself, not beside it for its owner to place
  summoner: boolean; // it goes on the card that summoned this one (the nearest of its owner's cards named in summoned_by)
  opponent: boolean; // a Lock: only the card's opponent may pay it
  each?: string; // one goes on each face-up Unit its owner controls of this affiliation ("aff-volcanic each undead": Dark Sovereign)
}
/**
 * One thing a card does by itself (the `effects` cell): "passive kill: status overheal 2 on self".
 *   when   the moment it happens (EFFECT_WHENS)
 *   passive  it is a "Passive:" effect, so it is stopped while the card is Entrenched, Comatose, Frozen, Locked or Stunned
 *   words  what it does, word by word (the first is the verb: EFFECT_VERBS)
 *   on     whom it is done to (EFFECT_TARGETS); '' = the verb's own default
 *   conds  every "if …" that must hold, word by word ("!" in front of the first word turns one round)
 */
export interface CardEffect { when: string; passive: boolean; words: string[]; on: string; conds: string[][] }
export const EFFECT_WHENS = [
  'enter', 'hit', 'attack', 'kill', 'shieldbreak', 'shield_gone', 'hurt', 'spell_hurt', 'damaged', 'destroyed', 'ally_destroyed', 'foe_destroyed', 'emperor_damaged',
  'start', 'any_start', 'end', 'attack_phase', 'tap', 'targeted', 'use', 'drawn', 'cost', 'expired', 'any_end', 'any_summon', 'ally_summon', 'any_drawn', 'any_destroyed', 'trigger', 'click', 'ally_spell', 'foe_summon', 'host_damaged', 'host_attacks', 'attacked', 'foe_moved', 'fractal', 'ally_fractal', 'deal', 'take', 'frenzy', 'aura', 'always', 'rolled', 'play_if', 'unit_lost',
] as const;
export const EFFECT_VERBS = ['status', 'damage', 'wound', 'heal', 'health', 'gain', 'draw', 'summon', 'destroy', 'lock', 'shuffle', 'transfer', 'steal', 'lose', 'overload', 'sp', 'pay', 'hold', 'counter', 'link', 'split', 'search', 'reveal', 'discount', 'rebirth', 'clone', 'choose', 'ungive', 'cooldown', 'tierup', 'veil', 'exit', 'ambush', 'mode', 'snare', 'raise', 'resurrect', 'copy', 'bank', 'spring', 'crypt', 'templar', 'tundra', 'refund', 'spend', 'spellward', 'biome_off', 'lava', 'done', 'mark', 'hold_it', 'host', 'cloak', 'taunt', 'unlink', 'cleanse', 'recycle', 'clear_spells', 'rehand_foe', 'aff', 'peek_hand', 'toss', 'feast', 'knives', 'blob', 'devilcoin', 'rehand', 'nospells', 'pest', 'attach_brought', 'recast', 'choose_lane', 'move', 'swap', 'tornado', 'pull', 'riptide', 'coral', 'retap', 'hold_lane', 'divide', 'pay_any', 'mark_add', 'end_summoner', 'become', 'unbecome', 'void_walk', 'rise', 'melstone', 'discard_top', 'take_discard', 'crossing', 'crosser', 'soul', 'illusion', 'transmit', 'challenge', 'tier3', 'untier', 'branch', 'unbranch', 'shadow', 'vines', 'smite', 'missmark', 'clear_biome', 'echo', 'encore', 'banish', 'gaze', 'bargain', 'repeat', 'resurge', 'vanish', 'peek_top', 'reveal_triggers', 'collect', 'collect_tap', 'tribunal', 'cordy', 'clan_go', 'burn_move', 'unburn', 'unstatus', 'also_aff', 'eel', 'clam', 'berry', 'sun_mark', 'sun_reset', 'sun_turn', 'wail', 'bell_on', 'segments', 'look', 'more_actions', 'rest_hits', 'legion', 'entomb', 'unentomb', 'archmage_peek', 'incinerate', 'devour', 'reflect', 'warlord', 'conquest', 'aim', 'intercede', 'wrath', 'rewind', 'sever', 'recall', 'reactor', 'mark_look', 'secret'] as const;
export const EFFECT_TARGETS = ['self', 'target', 'attacker', 'attacker_unit', 'front', 'front_or_emperor', 'target_lane', 'adjacent', 'allies_adjacent', 'allies_range', 'lane', 'lane_one', 'emperor', 'foe_emperor', 'emperors', 'it', 'allies', 'foes', 'afflicted', 'across_it', 'everyone', 'actor_weakest', 'in_lanes', 'damaged', 'it_lane', 'tiered', 'all_cards', 'host', 'pick_foe_open', 'pick_foe', 'pick_foe_all', 'pick_foe_range', 'pick_front', 'pick_ally', 'pick_ally_all', 'pick_ally_range', 'pick_any', 'summoned', 'paired', 'pick_support'] as const;
/** Reads an `effects` cell. Anything it can't read is reported in `problems` and left out. */
export function parseEffects(cell: string, problems: string[] = []): CardEffect[] {
  const out: CardEffect[] = [];
  for (const raw of cell.split(';').map((r) => r.trim()).filter(Boolean)) {
    const m = /^(passive\s+)?([a-z_]+)\s*:\s*(.+)$/i.exec(raw);
    if (!m || !(EFFECT_WHENS as readonly string[]).includes(m[2].toLowerCase())) {
      problems.push(`"${raw}" doesn't start with a moment the table knows (${EFFECT_WHENS.join(', ')})`);
      continue;
    }
    const when = m[2].toLowerCase();
    const [action, ...ifs] = m[3].split(/\s+if\s+/i);
    const onMatch = /\s+on\s+([a-z_]+)\s*$/i.exec(action);
    const on = onMatch ? onMatch[1].toLowerCase() : '';
    if (on && !(EFFECT_TARGETS as readonly string[]).includes(on)) {
      problems.push(`"${raw}": "${on}" isn't someone an effect can be done to (${EFFECT_TARGETS.join(', ')})`);
      continue;
    }
    // (a summoned unit's name keeps its capitals: "summon Skell-Mini x2")
    const words = (onMatch ? action.slice(0, onMatch.index) : action).trim().split(/\s+/);
    words[0] = words[0].toLowerCase();
    const acts = !['deal', 'take', 'frenzy', 'aura', 'always', 'cost', 'trigger', 'play_if'].includes(when);
    if (acts && !(EFFECT_VERBS as readonly string[]).includes(words[0])) {
      problems.push(`"${raw}": "${words[0]}" isn't something an effect can do (${EFFECT_VERBS.join(', ')})`);
      continue;
    }
    out.push({ when, passive: !!m[1], words: ['summon', 'choose'].includes(words[0]) ? words : words.map((w) => w.toLowerCase()), on, conds: ifs.map((c) => c.trim().toLowerCase().split(/\s+/)) });
  }
  return out;
}
/** What the `while_in_play` cell can ask for: it holds for as long as the card is face-up in play. */
export const WHILE_IN_PLAY = ['reveal_hands', 'limbo_discards', 'tap_harvest', 'no_dark_spend', 'steal_dark', 'tap_relock', 'untouchable', 'calling', 'remaining_gate', 'jumps', 'needs_gate', 'intangible', 'double_lanes'] as const;
/** The secret rares (Calling Pillar, Realm Beyond Comprehension, The Remaining): the Random Deck button never picks them. */
export const isSecretRare = (c: { whileInPlay: string[] }) => c.whileInPlay.some((t) => t === 'calling' || t === 'remaining_gate' || t === 'jumps');

export const MAX_TIERS = 3;
const ROMAN = ['', 'I', 'II', 'III', 'IV', 'V'];
/** 2 -> "II" */
export function roman(n: number) {
  return ROMAN[n] ?? String(n);
}

export interface CardDb {
  list: CardDef[]; // the cards of the set, sorted by set number (what the deck builder shows)
  spawnOnly: CardDef[]; // cards with no number: summoned units, found only in the Spawn menu
  byNumber: Map<number, CardDef>; // every card, spawn-only ones included
  warnings: string[];
}

/** "Skell-Mini x2/Chicken" -> [{ name: 'skell-mini', count: 2 }, { name: 'chicken', count: 1 }] */
function summonList(value: string) {
  return splitTags(value).map((part) => {
    const m = part.match(/^(.*?)\s*(?:x|×)\s*(\d+)$/);
    return m ? { name: m[1].trim(), count: Math.max(1, Math.min(9, Number(m[2]))) } : { name: part, count: 1 };
  });
}
function splitTags(value: string): string[] {
  return value
    .split('/')
    .map((v) => v.trim().toLowerCase())
    .filter((v) => v !== '');
}

export function isEmperor(card: CardDef): boolean {
  return card.types.includes('emperor');
}

// Excel turns a cell like 4/2 into a date as it opens a .csv (whatever the cell's format or the automatic
// conversion settings say), and saves it back as "2-Apr". In the cells that hold numbers, such a date is read
// back as what was typed: month/day (2-Apr → 4/2, 3-Dec → 12/3, and a full 4/2/2026 → 4/2).
const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
const NUMBER_CELLS = ['cost', 'damage', 'health', 'range', 'shield', 'buffer', 'thorns', 'heals', 'count', 'removal_cost', 'replay_cost', 'duration'];
export function undoExcelDate(cell: string): string {
  const v = cell.trim();
  let m = /^(\d{1,2})-([A-Za-z]{3})[A-Za-z]*$/.exec(v); // 2-Apr
  if (m && MONTHS.includes(m[2].toLowerCase())) return `${MONTHS.indexOf(m[2].toLowerCase()) + 1}/${Number(m[1])}`;
  m = /^([A-Za-z]{3})[A-Za-z]*-(\d{1,2})$/.exec(v); // Apr-02
  if (m && MONTHS.includes(m[1].toLowerCase())) return `${MONTHS.indexOf(m[1].toLowerCase()) + 1}/${Number(m[2])}`;
  m = /^(\d{1,2})\/(\d{1,2})\/\d{2,4}$/.exec(v); // 4/2/2026
  if (m) return `${Number(m[1])}/${Number(m[2])}`;
  return cell;
}

/**
 * Reads cards.csv. `abilitiesCsv` is data/emperor_abilities.csv: one row per Emperor ability, with the columns
 * emperor (the Emperor's card number, or its exact name), slot (1 or 2), name, cost ("3", or "2/dark" for
 * Dark Gerzite), cooldown (turns), text, and when (blank = your Attack Phase; see ABILITY_WHEN). Any other
 * column (emperor_name) is only there for you to read.
 */
export function parseCards(csvText: string, abilitiesCsv = ''): CardDb {
  const warnings: string[] = [];
  const byNumber = new Map<number, CardDef>();

  let spawnOnlyCount = 0;
  for (const { line, values } of csvToRecords(csvText)) {
    for (const col of NUMBER_CELLS) if (values[col]) values[col] = undoExcelDate(values[col]);
    const spawnOnly = /^(|summon(ed)?)$/i.test((values.number ?? '').trim()); // no number, or "summon": a summoned unit
    if (spawnOnly && !(values.name ?? '').trim()) continue; // an empty row
    // a card of another set: its number cell is its number in that set (Bones & Bruises 1), the game's own is past
    // the Base Set's (CONFIG.sets: 1001)
    const setCell = (values.set ?? '').trim().toLowerCase();
    const setId = Object.entries(CONFIG.sets).find(([id, st]) => id === setCell.replace(/\s+/g, '') || st.name.toLowerCase() === setCell)?.[0] ?? (setCell.replace(/\s+/g, '') || 'base');
    const setFrom = CONFIG.sets[setId]?.from ?? 0;
    if (!spawnOnly && setId !== 'base' && !CONFIG.sets[setId]) warnings.push(`cards.csv line ${line}: there is no set "${values.set}" (the sets are listed in CONFIG.sets: ${Object.keys(CONFIG.sets).join(', ')}).`);
    const number = spawnOnly ? SPAWN_ONLY_FROM + spawnOnlyCount++ : setFrom + Number.parseInt(values.number, 10);
    if (!Number.isFinite(number)) {
      warnings.push(`cards.csv line ${line}: the number "${values.number}" isn't a whole number, so the row was skipped.`);
      continue;
    }
    if (byNumber.has(number)) {
      warnings.push(`cards.csv line ${line}: card number ${number} is used twice; only the first one is kept.`);
      continue;
    }
    const types = splitTags(values.type);
    // the cost cell: a number, "3/7" (two ways to summon it), or a formula
    const costCell = (values.cost ?? '').trim();
    const costParts = costCell.split('/').map((v) => v.trim());
    const twoCosts = costParts.length > 1 && costParts.every((v) => /^\d+$/.test(v));
    const formula = costCell && !twoCosts && !/^\d+$/.test(costCell) && costCell !== '?' ? parseCostFormula(costCell) : null;
    if (typeof formula === 'string') warnings.push(`cards.csv line ${line}: the cost "${costCell}" can't be read: ${formula}. The card is free to play until this is fixed.`);
    const healthParts = (values.health ?? '').split('/').map((v) => Number.parseFloat(v)).map((n) => (Number.isFinite(n) && n > 0 ? n : null));
    const countParts = (values.count ?? '').split('/').map((v) => Number.parseInt(v, 10)).map((n) => (Number.isFinite(n) && n > 0 ? n : null));
    const costNum = typeof formula === 'object' && formula ? Number.NaN : Number.parseInt(values.cost, 10);
    // several ways to summon it: two costs, or one cost with two healths or two counts (health 25/5, count 1/4)
    const shapes = Math.max(twoCosts ? costParts.length : 1, healthParts.length, countParts.length);
    const severalForms = twoCosts || (shapes > 1 && Number.isFinite(costNum));
    if (!severalForms && healthParts.length > 1) warnings.push(`cards.csv line ${line}: the health "${values.health}" has two numbers but the cost isn't a number, so only the first is used.`);
    const removalCell = values.removal_cost ?? values['removal cost'] ?? '';
    const replayCell = values.replay_cost ?? values['replay cost'] ?? '';
    const saysDark = (cell: string) => /\b(dark|dg)\b/i.test(cell); // "2/dark", "2 dark", "2 DG"
    const turnsCell = values.turns ?? values.turn_count ?? values['turn count'] ?? '';
    const onPlay = splitTags((values.on_play ?? values['on play'] ?? '').replace(/[,;]/g, '/')).map((t) => t.replace(/[\s-]+/g, '_'));
    const whileInPlay = splitTags((values.while_in_play ?? values['while in play'] ?? '').replace(/[,;]/g, '/')).map((t) => t.replace(/[\s-]+/g, '_'));
    const strayWhile = whileInPlay.filter((t) => !(WHILE_IN_PLAY as readonly string[]).includes(t));
    if (strayWhile.length) warnings.push(`cards.csv line ${line}: "${strayWhile.join('", "')}" in the while_in_play column isn't something the table can do (use ${WHILE_IN_PLAY.join(', ')}).`);
    // "lock 3", "lock 2 dark", "lock 4 here opponent", "burn", "weakness 2"
    const brings: CardBrings[] = (values.brings ?? '').split(/[\/;]/).map((part) => part.trim().toLowerCase()).filter(Boolean).map((part) => {
      const words = part.split(/\s+/);
      const flags = ['dark', 'here', 'opponent', 'summoner', 'each'];
      const number = words.slice(1).find((w) => /^\d+$/.test(w));
      const eachAt = words.indexOf('each');
      const each = eachAt > 0 ? words[eachAt + 1] : undefined; // "each undead": the affiliation after it
      return {
        token: words[0] === 'lock' ? 'locked' : words[0],
        value: number ? Number.parseInt(number, 10) : null,
        dark: words.includes('dark'), here: words.includes('here'), opponent: words.includes('opponent'), summoner: words.includes('summoner'),
        ...(each ? { each } : {}),
        stray: words.slice(1).filter((w, i) => !flags.includes(w) && w !== number && !(each && i + 1 === eachAt + 1)),
      };
    }).filter((b) => {
      if (b.stray.length) warnings.push(`cards.csv line ${line}: brings "${b.token} … ${b.stray.join(' ')}" has a word the table doesn’t know (it knows a number, dark, here, opponent, summoner and each + an affiliation).`);
      return true;
    }).map(({ stray: _stray, ...b }) => b);
    const ends = splitTags((values.ends ?? '').replace(/[,;]/g, '/')).map((t) => t.replace(/[\s-]+/g, '_'));
    const strayEnds = ends.filter((t) => !(ENDS as readonly string[]).includes(t));
    if (strayEnds.length) warnings.push(`cards.csv line ${line}: ends "${strayEnds.join(', ')}" isn’t one the table knows (${ENDS.join(', ')}).`);
    const untapCell = (values.on_untap ?? values['on untap'] ?? '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    const onUntap: CardDef['onUntap'] = untapCell === 'lose_tokens' || untapCell === 'swap_tokens' ? untapCell : '';
    if (untapCell && !onUntap) warnings.push(`cards.csv line ${line}: on_untap "${untapCell}" isn’t one the table knows (lose_tokens or swap_tokens).`);
    const strayOnPlay = onPlay.filter((t) => !(ON_PLAY as readonly string[]).includes(t));
    if (strayOnPlay.length) warnings.push(`cards.csv line ${line}: "${strayOnPlay.join('", "')}" in the on_play column isn't something the table can do (use ${ON_PLAY.join(', ')}).`);
    const limitNum = Number.parseInt(values.limit, 10);
    const tiersNum = Number.parseInt(values.tiers, 10);
    const rangeNum = Number.parseFloat(values.range ?? '');
    const healthNum = Number.parseFloat(values.health ?? '');
    const yes = (v: string | undefined) => /^(y|yes|true|1|x)$/i.test(v ?? '');
    const whole = (v: string | undefined) => { const n = Number.parseInt(v ?? '', 10); return Number.isFinite(n) && n > 0 ? n : null; };
    const leanTags = splitTags((values.leans ?? values.lean ?? '').replace(/[,;]/g, '/')).map((t) => t.replace(/[\s-]+/g, '_')); // "direct attack" = direct_attack
    const unknownLeans = leanTags.filter((t) => !(ARCHETYPE_IDS as readonly string[]).includes(t));
    if (unknownLeans.length) warnings.push(`cards.csv line ${line}: "${unknownLeans.join('", "')}" in the leans column isn't an archetype (use ${ARCHETYPE_IDS.join(', ')}).`);
    if (leanTags.length > 5) warnings.push(`cards.csv line ${line}: ${leanTags.length} archetypes in the leans column; a card leans toward 5 at most (best fit first), so only the first 5 count.`);
    const roleTags = (values.roles ?? values.role ?? '').split(/[|\/;,]/).map((t) => t.trim().toLowerCase().replace(/[\s_-]+/g, ' ')).filter(Boolean);
    const unknownRoles = roleTags.filter((t) => !(ROLES as readonly string[]).includes(t));
    if (unknownRoles.length) warnings.push(`cards.csv line ${line}: "${unknownRoles.join('", "')}" in the roles column isn't a role (use ${ROLES.join(', ')}).`);
    const card: CardDef = {
      number,
      spawnOnly,
      name: values.name || `Card ${number}`,
      image: (values.image ?? '').split('/')[0].trim(),
      // ("a/b" in the image column: one art for each of a two-cost card's forms, as the cost column has 3/7)
      ...((values.image ?? '').includes('/') ? { formImages: (values.image ?? '').split('/').map((x) => x.trim()) } : {}),
      // Emperors have no rarity, and neither do spawn-only cards: for them a blank cell is right, not unfinished
      rarity: (values.rarity || (spawnOnly || types.includes('emperor') ? 'none' : 'unassigned')).toLowerCase(),
      types: types.length ? types : ['unassigned'],
      cost: Number.isFinite(costNum) ? costNum : null,
      costDark: /^\s*(dark|dg|dark[ _-]?gerzite)\s*$/i.test(values.cost_type ?? values['cost type'] ?? ''),
      forms: severalForms
        ? Array.from({ length: shapes }, (_, k) => ({
            cost: twoCosts ? Number.parseInt(costParts[k] ?? costParts[0], 10) : costNum,
            health: healthParts[k] ?? healthParts[0] ?? null,
            count: countParts[k] ?? countParts[0] ?? null,
          }))
        : null,
      costFormula: typeof formula === 'object' ? formula : null,
      affiliations: splitTags(values.affiliation).length ? splitTags(values.affiliation) : ['unassigned'],
      limit: spawnOnly ? 0 : Number.isFinite(limitNum) && limitNum > 0 ? limitNum : (RARITY_LIMITS[(values.rarity || '').toLowerCase()] ?? DEFAULT_LIMIT),
      startingHand: !/^(n|no|never|false|0|x)$/i.test(values.starting_hand ?? values['starting hand'] ?? ''),
      set: setId,
      setNumber: spawnOnly ? 0 : number - setFrom,
      tiers: 1, // worked out just below, from its type (see maxTier)
      arrival: /^\s*ambush\s*$/i.test(values.arrival ?? '') ? 'ambush' : 'entrenched',
      entrenchedTurns: Math.max(1, Math.min(9, Number.parseInt((values.arrival ?? '').match(/\d+/)?.[0] ?? '1', 10))),
      discardAura: yes(values.discard_aura ?? values['discard aura']),
      movement: /^fly/i.test(values.movement ?? '') ? 'flying' : /^ground/i.test(values.movement ?? '') ? 'ground' : '',
      range: Number.isFinite(rangeNum) && rangeNum >= 0 ? rangeNum : null,
      rangeText: (values.range ?? '').trim(),
      damage: (values.damage ?? '').trim(),
      shield: (values.shield ?? '').trim(),
      buffer: (values.buffer ?? '').trim(),
      thorns: (values.thorns ?? '').trim(),
      heals: (values.heals ?? values.heal ?? '').trim(),
      duration: (values.duration ?? '').trim(),
      statsOverride: (values.stats ?? '').trim(),
      traits: (values.traits ?? values.lines ?? '').split('|').map((t) => t.trim()).filter(Boolean),
      flavor: (values.flavor ?? values.flavour ?? values.flavor_text ?? '').replace(/\r/g, '').trim(),
      art: {
        x: Number.parseFloat(values.art_x ?? '') || 0,
        y: Number.parseFloat(values.art_y ?? '') || 0,
        zoom: Number.parseFloat(values.art_zoom ?? '') > 0 ? Number.parseFloat(values.art_zoom) : 100,
      },
      text: (values.text ?? values.description ?? '').replace(/\r/g, '').replace(/\\n/g, '\n').split('\n').map((l) => l.trim()).filter(Boolean).join('\n'),
      health: Number.isFinite(healthNum) && healthNum > 0 ? healthNum : null,
      sharesLane: spawnOnly || yes(values.shares_lane ?? values['shares lane']),
      arrivesWith: summonList(values.arrives_with ?? values['arrives with'] ?? ''),
      destroyedSummons: summonList(values.destroyed_summons ?? values['destroyed summons'] ?? ''),
      summonedBy: splitTags(values.summoned_by ?? values['summoned by'] ?? ''),
      spreadUnit: (values.spread_unit ?? values['spread unit'] ?? '').trim(),
      extraSlots: [
        ...new Set([
          // "Spell slots", "lanes", "Lane 3" and "spell" all mean the same kind of slot
          ...splitTags((values.extra_slots ?? values['extra slots'] ?? '').replace(/[,;]/g, '/')).map((t) => t.replace(/\bslots?\b/g, '').replace(/\d+/g, '').trim().replace(/s$/, '')).filter(Boolean),
          ...(yes(values.biome_slot ?? values['biome slot']) ? ['biome'] : []), // the column's old name
        ]),
      ],
      count: Number.isFinite(Number.parseInt(values.count ?? '', 10)) && Number.parseInt(values.count, 10) > 0 ? Number.parseInt(values.count, 10) : null,
      turns: whole((turnsCell.match(/\d+/) ?? [''])[0]),
      turnsTimer: /\bup\b/i.test(turnsCell) ? 'up' : /start|begin/i.test(turnsCell) ? 'start' : /end/i.test(turnsCell) ? 'end' : null,
      brings,
      ends: ends.filter((t) => (ENDS as readonly string[]).includes(t)),
      turnsUnset: !/\d/.test(turnsCell) && turnsCell.includes('?'),
      removalCost: whole(removalCell),
      removalDark: saysDark(removalCell),
      replayCost: whole(replayCell),
      replayDark: saysDark(replayCell),
      onPlay: onPlay.filter((t) => (ON_PLAY as readonly string[]).includes(t)),
      onUntap: onUntap,
      fieldAura: (values.field_aura ?? values['field aura'] ?? '').trim().toLowerCase(),
      whileInPlay: whileInPlay.filter((t) => (WHILE_IN_PLAY as readonly string[]).includes(t)),
      effects: (() => {
        const problems: string[] = [];
        const list = parseEffects((values.effects ?? '').trim(), problems);
        for (const why of problems) warnings.push(`cards.csv line ${line}: effects: ${why}.`);
        return list;
      })(),
      destroyedGains: (() => {
        const cell = (values.destroyed_gains ?? values['destroyed gains'] ?? '').trim().toLowerCase();
        const m = /^([a-z-]+)\s+(\d+|double)((?:\s+(?:opponent|each))*)$/.exec(cell);
        if (cell && !m) warnings.push(`cards.csv line ${line}: the destroyed_gains cell "${cell}" isn't understood (write it like "gerzite 1", "gerzite 1 opponent each" or "dark-gerzite double").`);
        return m ? { token: m[1], amount: m[2] === 'double' ? 0 : Number(m[2]), double: m[2] === 'double', opponent: /\bopponent\b/.test(m[3]), each: /\beach\b/.test(m[3]) } : null;
      })(),
      freedGains: splitTags((values.freed_gains ?? values['freed gains'] ?? '').replace(/[,;]/g, '/')).map((t) => {
        const m = t.match(/^(.*?)\s*(\d+)?$/)!;
        return { effect: m[1].trim().replace(/\s+/g, '-'), value: m[2] ? Number.parseInt(m[2], 10) : 1 };
      }).filter((g) => g.effect),
      leans: [...new Set(leanTags.filter((t) => (ARCHETYPE_IDS as readonly string[]).includes(t)))],
      roles: ROLES.filter((r) => roleTags.includes(r)),
      abilities: splitTags((values.abilities ?? values.ability ?? '').replace(/[,;]/g, '/')).filter((a) => (ABILITIES as readonly string[]).includes(a)),
      emperorAbilities: [],
    };
    if (isEmperor(card)) card.limit = 1;
    card.tiers = maxTier(card);
    // card types never dealt into a starting hand: noStartingHand in the settings (none at the moment)
    if (card.types.some((t) => CONFIG.noStartingHand.includes(t))) card.startingHand = false;
    if (Number.isFinite(tiersNum)) card.tiers = Math.max(1, Math.min(card.tiers, tiersNum)); // the column can only lower it
    byNumber.set(number, card);
  }

  // Emperor abilities: each row is filed under its Emperor
  for (const { line, values } of abilitiesCsv ? csvToRecords(abilitiesCsv) : []) {
    const who = (values.emperor ?? values.number ?? '').trim();
    if (!who && !(values.name ?? '').trim()) continue; // an empty row
    const at = `emperor_abilities.csv line ${line}`;
    const card = /^\d+$/.test(who) ? byNumber.get(Number.parseInt(who, 10)) : [...byNumber.values()].find((c) => c.name.toLowerCase() === who.toLowerCase());
    if (!card) {
      warnings.push(`${at}: there is no card "${who}", so the row was skipped. (The emperor column takes the Emperor's card number or its exact name.)`);
      continue;
    }
    if (!isEmperor(card)) {
      warnings.push(`${at}: ${card.name} isn't an Emperor, so the row was skipped.`);
      continue;
    }
    const slot = Number.parseInt(values.slot ?? '', 10);
    if (!(slot >= 1 && slot <= EMPEROR_ABILITY_SLOTS)) {
      warnings.push(`${at}: the slot "${values.slot ?? ''}" has to be a number from 1 to ${EMPEROR_ABILITY_SLOTS}, so the row was skipped.`);
      continue;
    }
    if (card.emperorAbilities.some((a) => a.slot === slot)) {
      warnings.push(`${at}: ${card.name} already has an Ability ${slot}; only the first one is kept.`);
      continue;
    }
    const costCell = values.cost ?? '';
    const cost = Number.parseInt(costCell, 10);
    const cooldown = Number.parseInt(values.cooldown ?? values.turns ?? '', 10);
    if (costCell.trim() && !Number.isFinite(cost) && !/^\s*\?\s*$/.test(costCell)) warnings.push(`${at}: the cost "${costCell}" isn't a number, so ${card.name}'s Ability ${slot} is free until this is fixed.`);
    // the `when` cell: blank = the usual time (your Attack Phase); otherwise the words in it say when
    const whenCell = (values.when ?? values.timing ?? '').trim();
    const whenTags = splitTags(whenCell.replace(/[,;]/g, '/')).map((t) => t.replace(/\bphases?\b/g, '').trim().replace(/[\s-]+/g, '_').replace(/^(opponent|opponents|opponent's|enemy)(_turn)?$/, 'opponent_turn').replace(/^(any|anytime)$/, 'any_time'));
    const unknownWhen = whenTags.filter((t) => !ABILITY_WHEN[t]);
    if (unknownWhen.length) warnings.push(`${at}: "${unknownWhen.join(', ')}" in the when column isn't one of ${Object.keys(ABILITY_WHEN).join(', ')}, so it was ignored.`);
    const known = whenTags.filter((t) => ABILITY_WHEN[t]);
    card.emperorAbilities.push({
      phases: known.length ? [...new Set(known.flatMap((t) => ABILITY_WHEN[t].phases ?? []))].sort() : null,
      opponentTurn: known.some((t) => !!ABILITY_WHEN[t].opponentTurn),
      slot,
      name: (values.name ?? '').trim() || `Ability ${slot}`,
      cost: Number.isFinite(cost) && cost > 0 ? cost : 0,
      costVaries: /^\s*\?\s*$/.test(costCell),
      dark: /\b(dark|dg)\b/i.test(costCell) || /^\s*(dark|dg|dark[ _-]?gerzite)\s*$/i.test(values.cost_type ?? values['cost type'] ?? ''),
      cooldown: Number.isFinite(cooldown) && cooldown > 0 ? cooldown : 0,
      text: (values.text ?? values.effect ?? values.description ?? '').trim(),
      effects: (() => {
        const problems: string[] = [];
        const list = parseEffects((values.effects ?? '').trim(), problems);
        for (const why of problems) warnings.push(`${at}: effects: ${why}.`);
        return list;
      })(),
    });
    card.emperorAbilities.sort((a, b) => a.slot - b.slot);
  }

  const all = [...byNumber.values()].sort((a, b) => a.number - b.number);
  return { list: all.filter((c) => !c.spawnOnly), spawnOnly: all.filter((c) => c.spawnOnly), byNumber, warnings };
}

/** The stats a card can print, in the order cards list them. */
export const STAT_ICONS = ['health', 'sp', 'heals', 'shield', 'buffer', 'count', 'damage', 'thorns', 'range', 'turns', 'removal', 'replay'] as const;
export type StatIcon = (typeof STAT_ICONS)[number];
/** What each stat is called in words (the close-up, tooltips). */
export const STAT_NAMES: Record<StatIcon, string> = {
  health: 'Health', sp: 'SP', heals: 'Heals', shield: 'Shield', buffer: 'Buffer', count: 'Count', damage: 'Damage',
  thorns: 'Thorns', range: 'Range', turns: 'Turns', removal: 'Removal cost', replay: 'Reactivate cost',
};
/**
 * The stats printed on a card, in order: health (SP for a Building), what it heals, Shield, Buffer, Count,
 * damage, Thorns, range, its turn count, and a Biome's removal cost or a Tome's reactivate cost. Each value is
 * what the sheet says, so "12/3" and "?" are printed as they are. The `stats` cell replaces the whole row.
 */
export function cardStats(def: CardDef): { icon: StatIcon; value: string; dark?: boolean }[] {
  if (def.statsOverride) {
    return def.statsOverride
      .split('|')
      .map((part) => part.trim().match(/^([a-z_ ]+?)\s+(.+)$/i))
      .filter((m): m is RegExpMatchArray => !!m && (STAT_ICONS as readonly string[]).includes(m[1].toLowerCase()))
      .map((m) => ({ icon: m[1].toLowerCase() as StatIcon, value: m[2].trim() }));
  }
  const out: { icon: StatIcon; value: string; dark?: boolean }[] = [];
  const add = (icon: StatIcon, value: string | number | null | undefined, dark?: boolean) => {
    if (value !== null && value !== undefined && String(value).trim() !== '') out.push({ icon, value: String(value).trim(), ...(dark ? { dark } : {}) });
  };
  const health = def.forms ? def.forms.map((f) => f.health ?? '?').join('/') : def.health;
  add(def.types.includes('building') ? 'sp' : 'health', health);
  add('heals', def.heals);
  add('shield', def.shield);
  add('buffer', def.buffer);
  add('count', def.count);
  add('damage', def.damage);
  add('thorns', def.thorns);
  add('range', def.rangeText);
  add('turns', def.turnsTimer === 'up' && def.turns ? `1–${def.turns}` : (def.turns ?? (def.turnsUnset ? '?' : def.duration)));
  add('removal', def.removalCost, def.removalDark);
  add('replay', def.replayCost, def.replayDark);
  return out;
}
/**
 * The counters a Troop, Building or Emperor comes into play with (its shield, buffer and thorns cells): one
 * counter for each number in the cell, so "1/1/1/1" is four Shields of 1. Zeros and "?" give none; so does
 * every other kind of card (on a Spell these cells say what the Spell gives).
 */
export function arrivalCounters(def: CardDef): { effect: 'shield' | 'buffer' | 'thorns'; value: number }[] {
  if (!def.types.some((t) => t === 'troop' || t === 'building' || t === 'emperor')) return [];
  const out: { effect: 'shield' | 'buffer' | 'thorns'; value: number }[] = [];
  for (const effect of ['shield', 'buffer', 'thorns'] as const) {
    for (const part of def[effect].split('/')) {
      const n = Number.parseInt(part.trim(), 10);
      if (/^\d+$/.test(part.trim()) && n > 0) out.push({ effect, value: n });
    }
  }
  return out;
}

/** A card's cost, full health and Count the way it was summoned (form 0 unless the card has several and another was chosen). */
export function formOf(def: Pick<CardDef, 'cost' | 'health' | 'forms'> & { count?: number | null; types?: string[] }, form = 0, tier = 1): { cost: number | null; health: number | null; count: number | null } {
  const f = def.forms?.[form];
  const out = f ? { cost: f.cost, health: f.health, count: f.count } : { cost: def.cost, health: def.health, count: def.count ?? null };
  // a tiered Troop or Building has more health (each of a Count's units does)
  if (tier > 1 && def.types && out.health) out.health += tierHealth({ types: def.types }, out.health, tier);
  return out;
}

/**
 * The highest tier a card can merge up to, from its type (CONFIG.tierRules): Troops, Buildings and Biomes III,
 * Spells II (none for a Spell that costs 0), anything else and summoned units none (1).
 */
export function maxTier(def: Pick<CardDef, 'types' | 'cost' | 'forms' | 'spawnOnly'>): number {
  if (def.spawnOnly) return 1;
  const by = CONFIG.tierRules.maxByType;
  let max = Math.max(1, ...def.types.map((t) => by[t] ?? 1));
  const cheapest = def.forms ? Math.min(...def.forms.map((f) => f.cost)) : def.cost;
  if (def.types.includes('spell') && !def.types.some((t) => t !== 'spell' && (by[t] ?? 1) > 1) && cheapest === 0) max = 1;
  return Math.min(MAX_TIERS, max);
}
const tierUp = (n: number, percent: number) => (n > 0 ? Math.ceil((n * percent) / 100 - 1e-9) : 0);
const tierStatTypes = (def: Pick<CardDef, 'types'>) => def.types.includes('troop') || def.types.includes('building');
/** How much health (SP) a tier adds to a Troop or Building whose full health is `health`: 20% at Tier II and III, rounded up. */
export function tierHealth(def: Pick<CardDef, 'types'>, health: number | null, tier: number): number {
  return tier >= 2 && health && tierStatTypes(def) ? tierUp(health, CONFIG.tierRules.healthPercent) : 0;
}
/** A Troop or Building's damage cell at a tier: at Tier III each number goes up 20%, rounded up ("12/3" → "15/4"). */
export function tieredDamage(def: Pick<CardDef, 'types' | 'damage'>, tier: number): string {
  if (tier < 3 || !tierStatTypes(def)) return def.damage;
  return def.damage.replace(/\d+(\.\d+)?/g, (n) => String(Number(n) + tierUp(Number(n), CONFIG.tierRules.damagePercent)));
}
/** A Biome's removal cost at a tier (null = it has none). */
export function tieredRemoval(def: Pick<CardDef, 'types' | 'removalCost'>, tier: number): number | null {
  if (def.removalCost === null) return null;
  return def.removalCost + (def.types.includes('biome') ? (CONFIG.tierRules.biomeRemoval[Math.min(tier, MAX_TIERS)] ?? 0) : 0);
}
/** Gerzite a Spell gives back when it is merged up to `tier` from `from` (Tier II: 1). */
export function tierRefund(def: Pick<CardDef, 'types'>, from: number, tier: number): number {
  return def.types.includes('spell') && from < 2 && tier >= 2 ? CONFIG.tierRules.spellRefund : 0;
}
/** What the card's tier box says: ["Tier II - +2 Health", "Tier III - +2 Damage"]; [] for a card with no tiers. */
export function tierLines(def: CardDef): string[] {
  const out: string[] = [];
  const plus = (parts: number[]) => parts.map((n) => `+${n}`).join('/');
  for (let tier = 2; tier <= def.tiers; tier++) {
    const what: string[] = [];
    if (tierStatTypes(def)) {
      if (tier === 2) {
        const healths = def.forms ? [...new Set(def.forms.map((f) => f.health ?? 0))] : [def.health ?? 0];
        const add = healths.map((h) => tierHealth(def, h, 2));
        if (add.some((n) => n > 0)) what.push(`${plus(add)} ${def.types.includes('building') && !def.types.includes('troop') ? 'SP' : 'Health'}`);
      } else {
        const add = (def.damage.match(/\d+(\.\d+)?/g) ?? []).map((n) => tierUp(Number(n), CONFIG.tierRules.damagePercent));
        if (add.some((n) => n > 0)) what.push(`${plus(add)} Damage`);
      }
    }
    if (def.types.includes('spell') && tier === 2 && CONFIG.tierRules.spellRefund) what.push(`${CONFIG.tierRules.spellRefund} Gerzite Less`);
    if (def.types.includes('biome') && def.removalCost !== null) {
      const add = (CONFIG.tierRules.biomeRemoval[tier] ?? 0);
      if (add) what.push(`+${add} Removal Cost`);
    }
    if (what.length) out.push(`Tier ${roman(tier)} - ${what.join(', ')}`);
  }
  return out;
}

/**
 * Is this card a Lanespanner (one unit per lane)? 'always' = the Lanespanner descriptor on its own (Dark Order);
 * 'optional' = Lanespanner as one of two choices in a descriptor ("Ground/Lanespanner": Clay Soldiers may be
 * summoned in one lane or spread); 'never' otherwise.
 */
export function spanMode(def: Pick<CardDef, 'traits'>, trait = 'Lanespanner'): 'always' | 'optional' | 'never' {
  for (const t of def.traits) {
    const parts = t.split('/').map((x) => x.trim());
    if (!parts.includes(trait)) continue;
    return parts.length === 1 ? 'always' : 'optional';
  }
  return 'never';
}

/** "4 Troops, 5 health each" / "25 health": a way to summon a card, in words. */
export function formWords(f: { health: number | null; count: number | null }): string {
  return f.count && f.count > 1 ? `${f.count} Troops, ${f.health ?? '?'} health each` : `${f.health ?? '?'} health`;
}

/** A card's cost as a few characters, for its placeholder picture and lists: "4", "3/7", "X", or "–" if it has none. */
export function costLabel(def: Pick<CardDef, 'cost' | 'forms' | 'costFormula'>): string {
  if (def.forms) return [...new Set(def.forms.map((f) => f.cost))].join('/');
  if (def.costFormula) return 'X';
  return def.cost === null ? '–' : String(def.cost);
}

/** …and in words, for the card's close-up: "3 or 7 Gerzite (you choose as you play it)", "X: 2 + cards removed (you choose)". */
export function costWords(def: Pick<CardDef, 'cost' | 'forms' | 'costFormula' | 'costDark'>): string {
  const coin = def.costDark ? 'Dark Gerzite' : 'Gerzite';
  if (def.forms) {
    const costs = [...new Set(def.forms.map((f) => f.cost))];
    if (costs.length === 1) return `${costs[0]} ${coin}: you choose as you play it (${def.forms.map(formWords).join(', or ')})`;
    return `${costs.join(' or ')} ${coin}: you choose as you play it (${def.forms.map((f) => `${f.cost} → ${formWords(f)}`).join(', ')})`;
  }
  if (def.costFormula) return `worked out as you play it: ${describeFormula(def.costFormula)}`;
  return def.cost === null ? '' : `${def.cost} ${coin}`;
}

/**
 * Cards whose numbers changed (renamed cards moved so each block stays in alphabetical order): old number → new
 * number. Card stats saved before are moved over once (server/stats.ts); decks exported before are read by name.
 */
export const RENUMBERED: { id: string; map: Record<number, number> }[] = [
  { id: '2026-10-rares', map: {52: 50, 58: 51, 66: 52, 54: 53, 50: 54, 59: 58, 60: 59, 61: 60, 62: 61, 63: 62, 64: 63, 65: 64, 67: 65, 68: 66, 69: 67, 53: 68, 70: 69, 71: 70, 51: 71, 231: 227, 227: 228, 228: 229, 229: 230, 230: 231} },
  { id: '2026-10-pairs', map: { 98: 99, 99: 98, 211: 212, 212: 211, 291: 292, 292: 291 } },
];
/** Cards that were renamed: old name → new name (decks exported before a rename still come back right). */
export const RENAMED: Record<string, string> = {
  'Arellian Dunehauler': 'Dunehauler', 'Arellian Wildhorn': 'Wildhorn', 'Barrel Minis': 'Skell-Mateys', 'Frozen Zombie': 'Blockhead Zombie',
  'Orifice Clam': 'Cavity Clam', 'Wooly Bison': 'Wooly Tatanka', 'Potion of Essence': 'Granduer Potion',
};
/** A card's number as lists show it: "#12" in the Base Set, "B&B #1" in another set (CONFIG.sets tag). */
export function cardNo(card: Pick<CardDef, 'number' | 'set' | 'setNumber'>): string {
  const tag = CONFIG.sets[card.set]?.tag;
  return `${tag ? `${tag} ` : ''}#${card.setNumber ?? card.number}`;
}
/** "#12 Card 12", or just the name for a spawn-only card (it has no set number). */
export function cardLabel(card: CardDef): string {
  return card.spawnOnly ? card.name : `${cardNo(card)} ${card.name}`;
}

/** A card's rarity as shown to players: "Ultra-Rare", or nothing for a card that has none (Emperors, spawn-only cards). */
export function rarityLabel(card: CardDef): string {
  return card.rarity === 'none' ? '' : titleCase(card.rarity);
}

/** "ultra-rare" -> "Ultra-Rare", "troop/spell" -> "Troop/Spell" */
export function titleCase(text: string): string {
  return text.replace(/(^|[\s\-/])([a-z])/g, (_, sep: string, ch: string) => sep + ch.toUpperCase());
}

/** "a Troop", "an Emperor", "a Troop/Spell" */
export function typeWithArticle(card: CardDef): string {
  const label = card.types.includes('unassigned') ? 'card' : titleCase(card.types.join('/'));
  return (/^[aeiou]/i.test(label) ? 'an ' : 'a ') + label;
}
